import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './Chats.module.scss';
import { clickTracker, getSourceValue, linksObj } from '../../lib/common';

const FaqRedirectionPage = ({ selectedIssueVal }) => {
  const navigate = useNavigate();
  const source = getSourceValue();

  return (
    <div className={`${styles.ExecutiveBox} mb-20`}>
      <div className={`${styles.TextBox}`}>
        <div className={`${styles.ExecutiveIcon} csicon`} />
        <div className={`${styles.ChatText} font14 fw500 color111`}>
          <div>No problem!</div>
          For instant resolution you can check the following options.
          <div className={`${styles.LinkBtnGroup}`}>
            <button
              onClick={async () => {
                if (linksObj?.[selectedIssueVal]?.link) {
                  await clickTracker('instant_resolution', 'Raiseaticket');
                  navigate(`${linksObj?.[selectedIssueVal]?.link}?source=${source}`);
                }
              }}
              type="button"
              className={`${styles.LinkButton}`}
            >
              <div className="font12 fw600 color111 mr-10">{`${linksObj?.[selectedIssueVal]?.title} FAQs`}</div>
              <div className={`${styles.LinkIcon} csicon`} />
            </button>
            {selectedIssueVal === 'LEADS' && (
              <button
                onClick={async () => {
                  await clickTracker('instant_resolution', 'Raiseaticket');
                  navigate('/csportal/leads/contract_health');
                }}
                type="button"
                className={`${styles.LinkButton}`}
              >
                <div className="font13 fw600 color111 mr-10">Leads Healthcheck</div>
                <div className={`${styles.LinkIcon} csicon`} />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqRedirectionPage;
FaqRedirectionPage.propTypes = {
  selectedIssueVal: PropTypes.string,
};
